require('bootswatch/dist/lumen/bootstrap.css');
require('font-awesome/css/font-awesome.css');
require('chosen-js/chosen.css');
require('angular-timezone-selector/dist/angular-timezone-selector.css');
require('intl-tel-input/build/css/intlTelInput.css');
require('typeahead.js-bootstrap4-css/typeaheadjs.css');
require('../css/three-quarters.css');
require('../css/custom.css');
require('angular-selector/dist/angular-selector.css');
require('ui-cropper/compile/unminified/ui-cropper.css');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker.css');

require('popper.js');
require('bootstrap');
require('moment');
require('moment-timezone');
require('jquery');
require('jquery-ui/ui/widgets/sortable');
require('lodash');
require('angular');
require('angular-resource');
require('angular-route');
require('angular-selector');
require('angular-ui-sortable');
require('angular-utils-pagination');
require('angular-clipboard');
require('angular-drag-and-drop-lists');
require('marked');
require('angular-marked');
require('ng-file-upload');
require('ui-cropper');
require('intl-tel-input/build/js/utils');
require('intl-tel-input/build/js/intlTelInput');
require('international-phone-number/releases/international-phone-number');
require('chosen-js/chosen.jquery');
require('jstz');
require('angular-timezone-selector');
require('jscolor');
require('zxcvbn');
require('corejs-typeahead');
require('bootstrap-datepicker');
window.io = require('socket.io-client');
require('angular-socket-io');

import {
    AllSubmittedChecklistsController,
    AllUnsubmittedChecklistsController,
    AllArchivedChecklistsController,
    ArchivedChecklistsController,
    ChecklistCtrl,
    ChecklistSigningCtrl,
    ChecklistCreateCtrl,
    ChecklistUpdateCtrl,
    ChecklistViewCtrl,
    DashboardCtrl,
    DefinitionCreateCtrl,
    DefinitionCtrl,
    DefinitionsCtrl,
    DefinitionUpdateCtrl, DeleteChecklistController,
    HelpTextsCtrl,
    TagCreateCtrl,
    TagUpdateCtrl,
    MainCtrl,
    OrganisationCreateCtrl,
    OrganisationCtrl,
    OrganisationsCtrl,
    OrganisationSettingsFormCtrl,
    OrganisationUpdateCtrl,
    RegistrationFormCtrl,
    StripeAddCardCtrl,
    StripeUpdateCardCtrl,
    TeamsChecklistsController,
    UnfinishedChecklistsController,
    UserChecklistsController,
    UserClaimFormCtrl,
    UserFormCtrl,
    UserSettingsFormCtrl, WorkflowCtrl, WorkflowsCtrl
} from './controllers';

import {
    Age,
    BtnAdd20Items,
    BtnAddHeaderField,
    BtnAddItem,
    BtnBulkAdd,
    BtnBulkAddToggle,
    ConfirmCheckbox,
    ConvertToNumber,
    FullTitle,
    HelpPanelStick,
    ExclusivePopover,
    LogInForm,
    OkPassword,
    PreventDefault,
    RolesSelection,
    SearchAllChecklistsTypeahead,
    SubdomainPrefill,
    DefinitionTitlePrefill,
    WarnBeforeClose,
    CommentModal,
    DragToScroll,
    AutoHideFlash,
    ClickPrimarySaveButton,
    ClickSecondarySaveButton
} from "./directives";

import {
    MatchDefinitionRole,
    PasswordCount,
    Range,
    IncludedInURL,
    FilterWorkflow
} from "./filters";

import {
    EnvName,
    User,
    Organisation,
    Organisations,
    HelpTexts,
    SubdomainAvailability,
    DefinitionTitleAvailability,
    Roles,
    Tags,
    Image,
    Definitions,
    Definition,
    Favourites,
    Checklist,
    Signing,
    SignatureRemoving,
    StripeConfiguration,
    StripeSubscription,
    StripeSetupIntent,
    Zxcvbn,
    Socket,
    StripeCardUpdate,
    StripeCardRemove,
    ChecklistSearch,
    Notifications,
    ChecklistsInProgress,
    ChecklistsSignedOrSubmitted
} from './services';

import {config} from './config'
import atmtStar from './misc/atmt.star';
import atmtGroupStar from './misc/atmt.groupStar';
import atmtStickyBar from './misc/atmt.stickyBar';

const chklstyDeps = [
    'ui.sortable',
    'angularUtils.directives.dirPagination',
    'angular-clipboard',
    'angular-timezone-selector',
    'ngResource',
    'selector',
    'ngFileUpload',
    'internationalPhoneNumber',
    'hc.marked',
    'btford.socket-io',
    'dndLists',
    'uiCropper',
    atmtStar.name,
    atmtGroupStar.name,
    atmtStickyBar.name
];

const configuration = config(EnvName());
const app = angular.module('chklsty', chklstyDeps)
    .value('config', configuration)
    .factory('User', User)
    .factory('Organisation', Organisation)
    .factory('Organisations', Organisations)
    .factory('HelpTexts', HelpTexts)
    .factory('SubdomainAvailability', SubdomainAvailability)
    .factory('Roles', Roles)
    .factory('Tags', Tags)
    .factory('Image', Image)
    .factory('Definitions', Definitions)
    .factory('Definition', Definition)
    .factory('DefinitionTitleAvailability', DefinitionTitleAvailability)
    .factory('Favourites', Favourites)
    .factory('ChecklistsInProgress', ChecklistsInProgress)
    .factory('ChecklistsSignedOrSubmitted', ChecklistsSignedOrSubmitted)
    .factory('Checklist', Checklist)
    .factory('ChecklistSearch', ChecklistSearch)
    .factory('Signing', Signing)
    .factory('StripeSetupIntent', StripeSetupIntent)
    .factory('SignatureRemoving', SignatureRemoving)
    .factory('StripeConfiguration', StripeConfiguration)
    .factory('StripeSubscription', StripeSubscription)
    .factory('StripeCardUpdate', StripeCardUpdate)
    .factory('StripeCardRemove', StripeCardRemove)
    .factory('Notifications', Notifications)
    .factory('zxcvbn', Zxcvbn)
    .factory('Socket', Socket)
    .controller('MainCtrl', MainCtrl)
    .controller('DashboardCtrl', DashboardCtrl)
    .controller('UnfinishedChecklistsController', UnfinishedChecklistsController)
    .controller('TeamsChecklistsController', TeamsChecklistsController)
    .controller('ArchivedChecklistsController', ArchivedChecklistsController)
    .controller('AllSubmittedChecklistsController', AllSubmittedChecklistsController)
    .controller('AllArchivedChecklistsController', AllArchivedChecklistsController)
    .controller('AllUnsubmittedChecklistsController', AllUnsubmittedChecklistsController)
    .controller('DeleteChecklistController', DeleteChecklistController)
    .controller('UserChecklistsController', UserChecklistsController)
    .controller('DefinitionsCtrl', DefinitionsCtrl)
    .controller('DefinitionCtrl', DefinitionCtrl)
    .controller('DefinitionCreateCtrl', DefinitionCreateCtrl)
    .controller('DefinitionUpdateCtrl', DefinitionUpdateCtrl)
    .controller('WorkflowsCtrl', WorkflowsCtrl)
    .controller('WorkflowCtrl', WorkflowCtrl)
    .controller('OrganisationsCtrl', OrganisationsCtrl)
    .controller('OrganisationCtrl', OrganisationCtrl)
    .controller('OrganisationCreateCtrl', OrganisationCreateCtrl)
    .controller('OrganisationUpdateCtrl', OrganisationUpdateCtrl)
    .controller('OrganisationSettingsFormCtrl', OrganisationSettingsFormCtrl)
    .controller('HelpTextsCtrl', HelpTextsCtrl)
    .controller('TagCreateCtrl', TagCreateCtrl)
    .controller('TagUpdateCtrl', TagUpdateCtrl)
    .controller('ChecklistCtrl', ChecklistCtrl)
    .controller('ChecklistCreateCtrl', ChecklistCreateCtrl)
    .controller('ChecklistUpdateCtrl', ChecklistUpdateCtrl)
    .controller('ChecklistViewCtrl', ChecklistViewCtrl)
    .controller('ChecklistSigningCtrl', ChecklistSigningCtrl)
    .controller('UserFormCtrl', UserFormCtrl)
    .controller('UserSettingsFormCtrl', UserSettingsFormCtrl)
    .controller('RegistrationFormCtrl', RegistrationFormCtrl)
    .controller('UserClaimFormCtrl', UserClaimFormCtrl)
    .controller('StripeAddCardCtrl', StripeAddCardCtrl)
    .controller('StripeUpdateCardCtrl', StripeUpdateCardCtrl)
    .filter('matchDefinitionRole', MatchDefinitionRole)
    .filter('range', Range)
    .filter('passwordCount', PasswordCount)
    .filter('includedInURL', IncludedInURL)
    .filter('filterWorkflow', FilterWorkflow)
    .directive('preventDefault', PreventDefault)
    .directive('age', Age)
    .directive('logInForm', LogInForm)
    .directive('confirmCheckbox', ConfirmCheckbox)
    .directive('warnBeforeClose', WarnBeforeClose)
    .directive('convertToNumber', ConvertToNumber)
    .directive('btnAddHeaderField', BtnAddHeaderField)
    .directive('btnAddItem', BtnAddItem)
    .directive('btnAdd20Items', BtnAdd20Items)
    .directive('btnBulkAddToggle', BtnBulkAddToggle)
    .directive('btnBulkAdd', BtnBulkAdd)
    .directive('clickPrimarySaveButton', ClickPrimarySaveButton)
    .directive('clickSecondarySaveButton', ClickSecondarySaveButton)
    .directive('rolesSelection', RolesSelection)
    .directive('fullTitle', FullTitle)
    .directive('helpPanelStick', HelpPanelStick)
    .directive('exclusivePopover', ExclusivePopover)
    .directive('subdomainPrefill', SubdomainPrefill)
    .directive('definitionTitlePrefill', DefinitionTitlePrefill)
    .directive('dragToScroll', DragToScroll)
    .directive('okPassword', OkPassword)
    .directive('searchAllChecklistsTypeahead', SearchAllChecklistsTypeahead)
    .directive('commentModal', CommentModal)
    .directive('autoHideFlash', AutoHideFlash)
;

app.constant('GM_STAR_STATES', ['0', '1', '3', '2']);
app.constant('GM_STAR_CSS_NAMES', {
    '0': '',
    '1': 'atmt__star-state-1',
    '2': 'atmt__star-state-2',
    '3': 'atmt__star-state-3'
});

app.config((paginationTemplateProvider) => {
    paginationTemplateProvider.setPath('/front/dirPagination.tpl.html');
});

$(function () {
    $('body').on('click', event => {
        $('[data-toggle="popover"]').popover('hide');
        $('.exclusive-popover').popover('hide');
    });
    window.recaptchaCallback = token => {
        let form;
        if ($('#frm-logInForm').length) {
            form = $('#frm-logInForm');
        }
        if ($('#frm-registrationForm').length) {
            form = $('#frm-registrationForm');
        }
        if (window.Nette.validateForm(form[0])) {
            form.submit();
        } else {
            grecaptcha.reset();
        }
    };
});

$(() => {
    const url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }
});

Array.prototype.clean = function(deleteValue) {
    for (let i = 0; i < this.length; i++) {
        if (this[i] == deleteValue) {
            this.splice(i, 1);
            i--;
        }
    }
    return this;
};

window.location.getQueryParameter = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
